<template>
  <div class="iconBookmark">
    <svg v-if="active" xmlns="http://www.w3.org/2000/svg" width="20" height="28" viewBox="0 0 20 28" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 22L20 28V4C20 2.93913 19.5786 1.92172 18.8284 1.17157C18.0783 0.421427 17.0609 0 16 0H4C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4V28L10 22Z" fill="#EB5757"/>
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="28" viewBox="0 0 20 28" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 22L20 28V4C20 2.93913 19.5786 1.92172 18.8284 1.17157C18.0783 0.421427 17.0609 0 16 0H4C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4V28L10 22ZM2 24.468L10 19.668L18 24.468V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2H4C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4V24.468Z" fill="#A7A7A7"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: "IconBookmark",
  props: {
    active: Boolean
  }
}
</script>

<style scoped lang="scss">
.iconBookmark {
  cursor: pointer;
}
</style>